import type { User } from 'oidc-client-ts';
import * as React from 'react';
import { useMemo } from 'react';
import { AuthProvider, AuthProviderProps } from 'react-oidc-context';
import { authSourceToPath } from '../../AuthSource';
import { getAuthGlobalOptions } from '../../options';
import { OpenIDConnectEventHandler } from './OpenIDConnectEventHandler';

export interface IOpenIDConnectAuthProviderProps {
  children: React.ReactNode;
  /**
   * Scope dell'autenticazione
   */
  scope: string;
}

export function OpenIDConnectAuthProvider(
  props: IOpenIDConnectAuthProviderProps,
) {
  const authConfig = useMemo(() => {
    return {
      client_id: process.env.OIDC_CLIENT_ID ?? '',
      authority: process.env.OIDC_AUTHORITY ?? '',
      post_logout_redirect_uri:
        window.location.origin?.replace('http://', 'https://') +
        authSourceToPath(getAuthGlobalOptions().source),
      // Configurato direttamente in `useOpenIDConnectLogin`
      // redirect_uri: process.env.OIDC_REDIRECT_URI ?? '',
      response_type: 'code',
      scope: process.env.OIDC_SCOPE ?? props.scope ?? 'openid profile email',
      onSigninCallback: (_user: User | void): void => {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
      },
      automaticSilentRenew: false,
    } as AuthProviderProps;
  }, [props.scope]);

  return (
    <AuthProvider {...authConfig}>
      <OpenIDConnectEventHandler />
      {props.children}
    </AuthProvider>
  );
}
